module.exports = __webpack_public_path__ + "static/media/icon-more-vertical.20cc5c0a.svg";